import { render, staticRenderFns } from "./HomeStaticContentWithBanner.vue?vue&type=template&id=d80661fe&"
import script from "./HomeStaticContentWithBanner.vue?vue&type=script&lang=ts&"
export * from "./HomeStaticContentWithBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports